import React, { useContext } from "react";
import { Routes, Route, BrowserRouter as Router, Navigate } from "react-router-dom";
import InvitePage from "./pages/InvitePage";
import HomePage from "./pages/HomePage";
import SigninPage from "./pages/SigninPage";
import PasswordForgot from "./pages/PasswordForgotPage";
import { AuthContext } from "./contexts/AuthContext";
import GroupesPage from "./pages/GroupesPage";
import ContactsPage from "./pages/ContactsPage";
import MonProfilePage from "./pages/MonProfilePage";
import ContactPage from "./pages/ContactPage";
import NouveauGroupePage from "./pages/NouveauGroupePage";
import GroupeDetailsPage from "./pages/GroupeDetailsPage";
import AnnoncePage from "./pages/AnnoncePage";
import MeetingOverlay from "./components/MeetVideoComponents/MeetingOverlay";
import SignupPage from "./pages/SignupPage";
import Error404Page from "./pages/Error404Page";
import MeetOptionsPage from "./pages/MeetOptionsPage";
import WorkspaceSelectorPage from "./pages/WorkspaceSelectorPage";
import WorkspaceSettingsPage from "./pages/WorkspaceSettingsPage";
import RagFilesPage from "./pages/RagFilesPage";
import { ProtectedRoute, GuestRoute, WorkspaceRequired, WorkspacePermission } from "./ProtectedOrGuest";
import { useMeeting } from "./hooks/useMeeting";

// Garde de la route de réunion en plein écran.
// Sans session active (/reunion-start après un refresh, un retour ou un crash),
// on redirige vers /reunion au lieu d'afficher une page blanche.
function ReunionStartGate() {
  const { isMeetingActive } = useMeeting();
  if (isMeetingActive) return null;
  return <Navigate to="/reunion" replace />;
}

export default function RouterApp() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Router>
        <MeetingOverlay />
        <Routes>
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <Error404Page />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <HomePage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/workspaces"
            element={
              <ProtectedRoute>
                <WorkspaceSelectorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invite/:token"
            element={
              <ProtectedRoute>
                <InvitePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/workspace/settings"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <WorkspaceSettingsPage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/workspace/pelagie/fichiers"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <WorkspacePermission permission="MANAGE_FILES">
                    <RagFilesPage />
                  </WorkspacePermission>
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <GuestRoute>
                <SignupPage />
              </GuestRoute>
            }
          />
          <Route
            path="/password-forgot"
            element={user ? <HomePage /> : <PasswordForgot />}
          />
          <Route
            path="/groupes"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <GroupesPage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/annuaire"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <ContactsPage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contact/:username"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <ContactPage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/mon-profile"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <MonProfilePage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reunion"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <MeetOptionsPage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reunion-start"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <ReunionStartGate />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/groupes/nouveau-groupe"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <NouveauGroupePage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/groupes/:roomId"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <GroupeDetailsPage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
          <Route
            path="/annonces"
            element={
              <ProtectedRoute>
                <WorkspaceRequired>
                  <AnnoncePage />
                </WorkspaceRequired>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </>
  );
}
